import { get } from '@ember/object';
import { compare } from '@ember/utils';

/*
  Provides the same functionality as { sort } = '@ember/object/computed' but
  in a non-decorator property

  sortProperties = ['name:asc', 'age']
*/
export function sortByProperties<T>(
  items: Array<T> = [],
  sortProperties: Array<string>,
): Array<T> {
  let normalizedSortProperties = normalizeSortProperties(sortProperties);
  if (normalizedSortProperties.length === 0) {
    return items.slice();
  } else {
    return sortByNormalizedSortProperties<T>(items, normalizedSortProperties);
  }
}

function normalizeSortProperties(sortProperties: Array<string>) {
  return sortProperties.map((p) => {
    let [prop, direction] = p.split(':');
    direction = direction || 'asc';

    return [prop, direction];
  });
}

function sortByNormalizedSortProperties<T>(
  items: Array<T>,
  normalizedSortProperties: Array<Array<string>>,
) {
  return items.slice().sort((itemA, itemB) => {
    for (let i = 0; i < normalizedSortProperties.length; i++) {
      let [prop, direction] = normalizedSortProperties[i];
      // @ts-expect-error
      let result = compare(get(itemA, prop), get(itemB, prop));
      if (result !== 0) {
        return direction === 'desc' ? -1 * result : result;
      }
    }
    return 0;
  });
}

export function indexArrayByPropertyName<T>(
  items: Array<T>,
  propertyName: keyof T,
): { [propertyName: string]: T } {
  let byPropertyName: { [propertyName: string]: T } = {};
  for (let item of items) {
    if (item[propertyName] != null) {
      byPropertyName[item[propertyName] as string] = item;
    }
  }
  return byPropertyName;
}

export function groupArrayBy<T>(
  items: Array<T>,
  groupBy: (item: T) => string,
): { [groupByVal: string]: T[] } {
  let response: { [groupBy: string]: T[] } = {};
  for (let item of items) {
    let groupByVal = groupBy(item);
    if (groupByVal != null) {
      if (response[groupByVal] == null) {
        response[groupByVal] = [];
      }
      response[groupByVal].push(item);
    }
  }
  return response;
}

// Wraps an item in an array if it is not already an array.
export function arrayWrap<T>(item: T | T[]): T[] {
  if (Array.isArray(item)) {
    return item;
  } else {
    return [item];
  }
}
